import { parseFarmTimestamp } from './farmState.mjs';

const CARE_TYPES = ['water', 'weeds', 'pests'];

export const activeCareProblems = (cycle = {}, now = Date.now()) => {
  if (parseFarmTimestamp(cycle.maturesAt) <= now) return [];

  if (Number(cycle.careRuleVersion || 1) >= 2) {
    return CARE_TYPES.filter((type) => {
      const problem = cycle.careProblems?.[type];
      if (!problem) return false;
      const appearsAt = parseFarmTimestamp(problem.appearsAt);
      const expiresAt = parseFarmTimestamp(problem.expiresAt);
      return Number.isFinite(appearsAt)
        && Number.isFinite(expiresAt)
        && appearsAt <= now
        && expiresAt > now;
    });
  }

  return CARE_TYPES.filter((type) => {
    const dueAt = parseFarmTimestamp(cycle[`${type}DueAt`]);
    return cycle[`${type}DoneAt`] == null && Number.isFinite(dueAt) && dueAt <= now;
  });
};

const durationText = (secondsValue) => {
  const seconds = Math.max(0, Math.floor(Number(secondsValue) || 0));
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  if (minutes > 0 && rest > 0) return `${minutes}分${rest}秒`;
  if (minutes > 0) return `${minutes}分钟`;
  return `${rest}秒`;
};

export const careEffectMessage = (effect) => {
  if (effect?.type === 'time_bonus') return `成熟时间缩短 ${durationText(effect.seconds)}`;
  if (effect?.type === 'yield_bonus') return `预计收获增加 ${Math.max(0, Math.floor(Number(effect.amount) || 0))} 个`;
  return '照料完成';
};
